import { lazy } from 'react'
import type { RouteObject } from '@/types/router'

// Lazy loading das páginas
const Login = lazy(() => import('@/features/auth/pages/Login'))
const Register = lazy(() => import('@/features/auth/pages/Register'))
const ForgotPassword = lazy(() => import('@/features/auth/pages/ForgotPassword'))
const AuthCallback = lazy(() => import('@/features/auth/pages/AuthCallback'))
const Dashboard = lazy(() => import('@/features/dashboard/pages/Dashboard').then(mod => ({ default: mod.Dashboard })))
const Ranking = lazy(() => import('@/features/ranking/pages/Ranking'))
const Groups = lazy(() => import('@/features/groups/pages/Groups'))
const Account = lazy(() => import('@/features/settings/pages/Account'))
const Billing = lazy(() => import('@/features/settings/pages/Billing'))
const CheckInPage = lazy(() => import('@/features/check_in/pages/CheckInPage'))
const Feed = lazy(() => import('@/features/chat/pages/Feed'))
const SelectPlan = lazy(() => import('@/features/plans/pages/SelectPlan'))
const Tutorial = lazy(() => import('@/features/onboarding/pages/Tutorial'))
const BodyMeasurements = lazy(() => import('@/features/body_measurements/pages/BodyMeasurements'))
const Profile = lazy(() => import('@/features/profile/pages/Profile'))
const PublicChat = lazy(() => import('@/features/public-chat/pages/PublicChat'))
const BattlePass = lazy(() => import('@/features/battle-pass/pages/BattlePass'))

// Admin Pages
const AdminDashboard = lazy(() => import('@/features/admin/pages/AdminDashboard'))
const CheckInApproval = lazy(() => import('@/features/admin/pages/CheckInApproval'))
const AdminUsers = lazy(() => import('@/features/admin/pages/AdminUsers'))
const AdminChat = lazy(() => import('@/features/admin/pages/AdminChat'))
const RewardsManagement = lazy(() => import('@/features/admin/pages/RewardsManagement'))

export const publicRoutes: RouteObject[] = [
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/register',
    component: Register,
  },
  {
    path: '/forgot-password',
    component: ForgotPassword,
  },
  {
    path: '/auth/callback',
    component: AuthCallback,
  },
]

export const privateRoutes: RouteObject[] = [
  {
    path: '/',
    component: Dashboard,
  },
  {
    path: '/dashboard',
    component: Dashboard,
  },
  {
    path: '/tutorial',
    component: Tutorial,
  },
  {
    path: '/ranking',
    component: Ranking,
  },
  {
    path: '/groups',
    component: Groups,
  },
  {
    path: '/profile',
    component: Profile,
  },
  {
    path: '/settings/account',
    component: Account,
  },
  {
    path: '/settings/billing',
    component: Billing,
  },
  {
    path: '/check-in',
    component: CheckInPage,
  },
  {
    path: '/feed',
    component: Feed,
  },
  {
    path: '/chat',
    component: PublicChat,
  },
  {
    path: '/select-plan',
    component: SelectPlan,
  },
  {
    path: '/body-measurements',
    component: BodyMeasurements,
  },
  {
    path: '/battle-pass',
    component: BattlePass,
  },
]

// Rotas Administrativas separadas
export const adminRoutes: RouteObject[] = [
  {
    path: '/admin',
    component: AdminDashboard,
  },
  {
    path: '/admin/check-ins',
    component: CheckInApproval,
  },
  {
    path: '/admin/users',
    component: AdminUsers,
  },
  {
    path: '/admin/chat',
    component: AdminChat,
  },
  {
    path: '/admin/rewards',
    component: RewardsManagement,
  },
] 